import { Component } from '@verndale/core';
import { gsap } from 'gsap';

class Module extends Component {
  setupDefaults() {
    this.speed = this.el.dataset.speed || 30;
    this.defaultMargin = 22;
    this.breakpoint = null;
    this.breakpoints = {
      640: {
        margin: 44
      },
      1024: {
        margin: 22
      },
      1280: {
        margin: 32
      },
      1600: {
        margin: 40
      }
    };

    this.dom = {
      slider: this.el.querySelector('.client-portfolio__slider-inner'),
      slides: this.el.querySelectorAll('.client-portfolio__slide'),
      cards: [...this.el.querySelectorAll('.client-portfolio__card')]
    };

    this.handleWindowResize();
  }

  addListeners() {
    this.dom.slider.addEventListener(
      'mouseenter',
      this.handleMouseEnter.bind(this)
    );
    this.dom.slider.addEventListener(
      'mouseleave',
      this.handleMouseLeave.bind(this)
    );

    this.dom.cards.forEach(card => {
      card.addEventListener('focus', this.handleMouseEnter.bind(this));
      card.addEventListener('blur', this.handleMouseLeave.bind(this));
    });
    window.addEventListener('resize', this.handleWindowResize.bind(this));
  }

  handleWindowResize() {
    this.margin = this.defaultMargin;

    const previousBreakpoint = this.breakpoint;

    this.breakpoint = Object.keys(this.breakpoints)
      .reverse()
      .find(breakpoint => window.innerWidth >= parseInt(breakpoint));

    if (previousBreakpoint !== this.breakpoint) {
      if (this.slider) {
        this.slider.kill();
        this.calculateSizes();
        this.initSlider();
      } else {
        this.initSlider();
      }
    }
  }

  handleMouseEnter() {
    if (this.slider) {
      this.slider.pause();
    }
  }

  handleMouseLeave() {
    if (this.slider) {
      this.slider.play();
    }
  }

  calculateSizes() {
    // Reset cards height
    this.dom.cards.forEach(card => (card.style = null));

    // Get max card height
    const cardHeight = Math.max(
      ...this.dom.cards.map(card => card.offsetHeight)
    );

    // Set new height values
    // const margin = this.breakpoint
    //   ? this.breakpoints[this.breakpoint].margin
    //   : this.defaultMargin;
    const margin = 24;

    this.slideHeight = cardHeight * 2 + margin;
    this.slideWidth = this.dom.cards[0].offsetWidth + margin;

    this.dom.cards.forEach(card => (card.style.height = `${cardHeight}px`));
    this.dom.slider.style.height = `${this.slideHeight}px`;
  }

  initSlider() {
    this.calculateSizes();

    const totalWidth = this.slideWidth * this.dom.slides.length;
    const mod = gsap.utils.wrap(-this.slideWidth, totalWidth - this.slideWidth);

    gsap.set(this.dom.slides, { x: i => i * this.slideWidth });

    this.slider = gsap.timeline().to(this.dom.slides, {
      x: `-=${totalWidth}`,
      modifiers: {
        x: x => `${mod(parseFloat(x))}px`
      },
      duration: this.speed,
      ease: 'none',
      repeat: -1
    });
  }
}

export default Module;
